export default __webpack_public_path__ + "9784b50d541dfa9b9cce92e6667d71d2.png";